/**
 * Get user data as soon as possible
 */
App.namespace('es6.shared.user_data', () => {
  const getUser = () => {
    const deferred = jQuery.Deferred();

    // get user data if present, otherwise subscribe to its event
    if (window.__TGV_USER_DATA) {
      deferred.resolve(window.__TGV_USER_DATA);
    } else {
      $.subscribe('TGV_USER_DATA', (userData) => {
        deferred.resolve(userData);
      });
    }

    return deferred;
  };

  const setRollbar = (user) => {
    const payload = {
      userType: user.type,
      country: user.locationCountryCode,
    };

    if (user.id) {
      payload.person = {
        id: `${user.type}_${user.id}`,
      };
    }

    Rollbar.configure({ payload });

    return user;
  };

  getUser()
    .then(setRollbar);

  return {
    getUser,
  };
});
